
<portal to="cookieConsent">
    <div v-if="showBanner" class="cookie-consent-banner">
        <div class="cookie-banner-content">
            <div class="cookie-banner-header">
                <div class="cookie-text">
                    <h3>Datenschutzeinstellungen</h3>
                    <p>
                        Wir respektieren Ihre Privatsphäre und verwenden Cookies nur mit Ihrer
                        Einwilligung.
                    </p>
                </div>
            </div>

            <div class="cookie-categories">
                <div class="cookie-category essential">
                    <div class="category-header">
                        <i class="ri-shield-check-line"></i>
                        <div class="category-info">
                            <h4>Notwendige Cookies</h4>
                            <span class="category-required">Immer aktiv</span>
                        </div>
                    </div>
                    <p>Technisch erforderlich für die Grundfunktionen der Website.</p>
                </div>

                <div class="cookie-category marketing">
                    <div class="category-header">
                        <i class="ri-bar-chart-line"></i>
                        <div class="category-info">
                            <h4>Marketing-Cookies</h4>
                            <label class="toggle-switch">
                                <input
                                    type="checkbox"
                                    v-model="preferences.marketing"
                                    @change="updatePreferences"
                                />
                                <span class="slider"></span>
                            </label>
                        </div>
                    </div>
                    <p>Helfen uns, Ihnen relevante Werbung zu zeigen.</p>
                </div>
            </div>

            <div class="cookie-actions">
                <SiteButton @onClick="acceptEssentialOnly" variant="outline">
                    Nur notwendige akzeptieren
                </SiteButton>
                <SiteButton @onClick="acceptAll" variant="success">
                    Alle Cookies akzeptieren
                </SiteButton>
            </div>

            <div class="cookie-footer">
                <p class="cookie-links">
                    <a href="/privacy-policy" target="_blank">Datenschutz</a>
                    <span>•</span>
                    <a href="/impressum" target="_blank">Impressum</a>
                </p>
            </div>
        </div>
    </div>

    <div v-if="showModal" class="cookie-modal-overlay" @click="closeModal">
        <div class="cookie-modal" @click.stop>
            <div class="modal-header">
                <h3>Cookie-Einstellungen im Detail</h3>
                <button @click="closeModal" class="modal-close">
                    <i class="ri-close-line"></i>
                </button>
            </div>

            <div class="modal-content">
                <div class="cookie-details">
                    <div class="detail-section">
                        <h4>Notwendige Cookies</h4>
                        <p>
                            Diese Cookies sind für die Grundfunktionalität unserer Website
                            unerlässlich und können nicht deaktiviert werden. Sie werden nur für
                            technische Zwecke verwendet:
                        </p>
                        <ul>
                            <li>
                                <strong>Session-Management:</strong> Ermöglicht die Navigation
                                auf der Website
                            </li>
                            <li>
                                <strong>Sicherheit:</strong> Schützt vor Betrug und Missbrauch
                            </li>
                            <li>
                                <strong>Performance:</strong> Stellt sicher, dass die Website
                                ordnungsgemäß funktioniert
                            </li>
                        </ul>
                    </div>

                    <div class="detail-section">
                        <h4>Marketing-Cookies</h4>
                        <p>
                            Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer
                            Website interagieren. Die Daten werden verwendet, um:
                        </p>
                        <ul>
                            <li>
                                <strong>Personalisierte Werbung:</strong> Relevante Anzeigen auf
                                anderen Websites
                            </li>
                            <li>
                                <strong>Conversion-Tracking:</strong> Messung der Effektivität
                                unserer Marketingkampagnen
                            </li>
                            <li>
                                <strong>Website-Analysen:</strong> Verbesserung der
                                Nutzererfahrung
                            </li>
                        </ul>
                        <div class="cookie-provider">
                            <p><strong>Verwendete Dienste:</strong> Meta Pixel (Facebook)</p>
                            <p>
                                <strong>Rechtsgrundlage:</strong> Einwilligung gemäß Art. 6 Abs.
                                1 lit. a DSGVO
                            </p>
                        </div>
                    </div>

                    <div class="gdpr-notice">
                        <h4>Ihre Rechte</h4>
                        <p>Sie haben das Recht:</p>
                        <ul>
                            <li>Ihre Einwilligung jederzeit zu widerrufen</li>
                            <li>Auskunft über Ihre gespeicherten Daten zu erhalten</li>
                            <li>Die Löschung Ihrer Daten zu verlangen</li>
                            <li>
                                Eine Beschwerde bei der zuständigen Aufsichtsbehörde einzulegen
                            </li>
                        </ul>
                        <p>
                            Kontakt:
                            <a href="mailto:datenschutz@taxifusion.de"
                                >datenschutz@taxifusion.de</a
                            >
                        </p>
                    </div>
                </div>

                <div class="modal-actions">
                    <SiteButton @onClick="saveAndClose" variant="success">
                        Einstellungen speichern
                    </SiteButton>
                </div>
            </div>
        </div>
    </div>
</portal>
